
import React from "react";
import { useTranslation } from 'react-i18next';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface EmptyChartMessageProps {
  selectedView: "separate" | "combined";
  onViewChange: (value: "separate" | "combined") => void;
}

const EmptyChartMessage: React.FC<EmptyChartMessageProps> = ({ 
  selectedView, 
  onViewChange 
}) => {
  const { t } = useTranslation('common');
  
  return (
    <Card className="overflow-hidden">
      <CardHeader className="py-3">
        <div className="flex justify-between items-center">
          <CardTitle className="text-lg text-golf-700">{t('puttingTraining.charts.title')}</CardTitle>
          <Tabs value={selectedView} onValueChange={(v) => onViewChange(v as "separate" | "combined")}>
            <TabsList>
              <TabsTrigger value="separate">{t('puttingTraining.charts.tabs.individual')}</TabsTrigger>
              <TabsTrigger value="combined">{t('puttingTraining.charts.tabs.combined')}</TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
      </CardHeader>
      <CardContent className="p-4">
        <div className="text-center py-12 text-muted-foreground">
          {t('puttingTraining.charts.noExercises')}
        </div>
      </CardContent>
    </Card>
  );
};

export default EmptyChartMessage;
